import * as React from "react";
const SvgFiRrHandHoldingHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-holding-heart_svg__a)">
      <path
        fill="#062147"
        d="M8.965 24H4a4 4 0 0 1-4-4v-5a4 4 0 0 1 4-4h8.857a3.14 3.14 0 0 1 2.69 1.519l3.217-3.535a3.01 3.01 0 0 1 4.254-.2 3.02 3.02 0 0 1 .217 4.23l-6.8 7.637A10.01 10.01 0 0 1 8.965 24M4 13a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4.965a8 8 0 0 0 5.972-2.678l6.805-7.638a1.015 1.015 0 0 0-.072-1.421c-.2-.18-.46-.273-.728-.263a1 1 0 0 0-.7.329L15.816 15.2a3.16 3.16 0 0 1-2.516 2.052l-5.161.738a1 1 0 1 1-.284-1.98l5.162-.737a1.142 1.142 0 0 0-.16-2.273zm7-3.926a2 2 0 0 1-1.247-.436C8.041 7.264 6 5.2 6 3.2A3.11 3.11 0 0 1 9 0a2.88 2.88 0 0 1 2 .817A2.88 2.88 0 0 1 13 0a3.11 3.11 0 0 1 3 3.2c0 2-2.041 4.064-3.754 5.439A2 2 0 0 1 11 9.074M9 2a1.115 1.115 0 0 0-1 1.2c0 .9 1.151 2.39 3.006 3.879C12.849 5.59 14 4.1 14 3.2A1.115 1.115 0 0 0 13 2a1.115 1.115 0 0 0-1 1.2 1 1 0 0 1-2 0A1.115 1.115 0 0 0 9 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-holding-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandHoldingHeart;
